export const freight = [{
  value: "45",
  label: "～500g",
},
{
  value: "60",
  label: "0.5kg～1kg",
},
{
  value: "75",
  label: "1kg～1.5kg",
},
{
  value: "90",
  label: "1.5kg～2kg",
},
{
  value: "105",
  label: "2kg～2.5kg",
},
{
  value: "120",
  label: "2.5kg～3kg",
},
{
  value: "135",
  label: "3kg~3.5kg",
},
{
  value: "150",
  label: "3.5kg~4kg",
},
{
  value: "165",
  label: "4kg~4.5kg",
},
{
  value: "180",
  label: "4.5kg~5kg",
},

]
export const emsFreight = [
  {
    value: "30",
    label: "0～0.1kg",
  },
  {
    value: "35",
    label: "0.1kg～0.5kg",
  },
  {
    value: "45",
    label: "0.5kg～1kg",
  },
  {
    value: "65",
    label: "1kg～1.5kg",
  },
  {
    value: "75",
    label: "1.5kg～2kg",
  },
  {
    value: "85",
    label: "2kg~2.5kg",
  },
  {
    value: "100",
    label: "2.5kg~3kg",
  },


]